import AxiosCartCheckout from './axios_cart_checkout_api'

const ModuleCartCheckout = {
  state: {
    stateVerifyCheckoutToken: null,
    stateGenerateCartLinkV3: null,
    stateDeleteProductInCartV3: null,
    stateListUserAddressUPS: [],
    stateGetDetailCart: [],
    stateStartCheckout: null,
    statePrepareCheckout: null,
    stateConfirmCheckout: null,
    stateGenerateQuotationExample: [],
    stateCreateOrderV3: null,
    stateReadyShopCoupon: [],
    stateReadyPlatformCoupon: [],
    stateEstimateCostByProduct: []
  },
  mutations: {
    mutationVerifyCheckoutToken (state, data) {
      state.stateVerifyCheckoutToken = data
    },
    mutationGenerateCartLinkV3 (state, data) {
      state.stateGenerateCartLinkV3 = data
    },
    mutationDeleteProductInCartV3 (state, data) {
      state.stateDeleteProductInCartV3 = data
    },
    mutationListUserAddressUPS (state, data) {
      state.stateListUserAddressUPS = data
    },
    mutationGetDetailCart (state, data) {
      state.stateGetDetailCart = data
    },
    mutationStartCheckout (state, data) {
      state.stateStartCheckout = data
    },
    mutationPrepareCheckout (state, data) {
      state.statePrepareCheckout = data
    },
    mutationConfirmCheckout (state, data) {
      state.stateConfirmCheckout = data
    },
    mutationGenerateQuotationExample (state, data) {
      state.stateGenerateQuotationExample = data
    },
    mutationCreateOrderV3 (state, data) {
      state.stateCreateOrderV3 = data
    },
    mutationReadyShopCoupon (state, data) {
      state.stateReadyShopCoupon = data
    },
    mutationReadyPlatformCoupon (state, data) {
      state.stateReadyPlatformCoupon = data
    },
    mutationEstimateCostByProduct (state, data) {
      state.stateEstimateCostByProduct = data
    }
  },
  actions: {
    async actionsListPickupAddresses (context, data) {
      return AxiosCartCheckout.ListPickupAddresses(data)
    },
    async actionsListProductOptionsV3 (context, data) {
      return AxiosCartCheckout.ListProductOptionsV3(data)
    },
    async actionsChangeProductOptionV3 (context, data) {
      return AxiosCartCheckout.ChangeProductOptionV3(data)
    },
    async actionsGetCheckoutCart (context, data) {
      return AxiosCartCheckout.GetCheckoutCart(data)
    },
    async actionsListCheckoutCoupons (context, data) {
      return AxiosCartCheckout.ListCheckoutCoupons(data)
    },
    async actionsVerifyCheckoutToken (context, data) {
      const response = await AxiosCartCheckout.VerifyCheckoutToken(data)
      await context.commit('mutationVerifyCheckoutToken', response)
      return response
    },
    async actionsGenerateCartLinkV3 (context, data) {
      const response = await AxiosCartCheckout.GenerateCartLinkV3(data)
      await context.commit('mutationGenerateCartLinkV3', response)
      return response
    },
    async actionsDeleteProductInCartV3 (context, data) {
      const response = await AxiosCartCheckout.DeleteProductInCartV3(data)
      await context.commit('mutationDeleteProductInCartV3', response)
      return response
    },
    async actionsListUserAddressUPS (context) {
      const response = await AxiosCartCheckout.ListUserAddressUPS()
      await context.commit('mutationListUserAddressUPS', response)
    },
    async actionsGetDetailCart (context, data) {
      const response = await AxiosCartCheckout.GetDetailCart(data)
      await context.commit('mutationGetDetailCart', response)
      return response
    },
    async actionsStartCheckout (context, data) {
      const response = await AxiosCartCheckout.StartCheckout(data)
      await context.commit('mutationStartCheckout', response)
      return response
    },
    async actionsPrepareCheckout (context, data) {
      const response = await AxiosCartCheckout.PrepareCheckout(data)
      await context.commit('mutationPrepareCheckout', response)
      return response
    },
    async actionsConfirmCheckout (context, data) {
      const response = await AxiosCartCheckout.ConfirmCheckout(data)
      await context.commit('mutationConfirmCheckout', response)
      return response
    },
    async actionsGenerateQuotationExample (context, data) {
      const response = await AxiosCartCheckout.GenerateQuotationExample(data)
      await context.commit('mutationGenerateQuotationExample', response)
      return response
    },
    async actionsCheckoutCreateOrderV3 (context, data) {
      const response = await AxiosCartCheckout.CreateOrderV3(data)
      await context.commit('mutationCreateOrderV3', response)
      return response
    },
    async actionsReadyShopCoupon (context, data) {
      const response = await AxiosCartCheckout.ReadyShopCoupon(data)
      await context.commit('mutationReadyShopCoupon', response)
    },
    async actionsReadyPlatformCoupon (context, data) {
      const response = await AxiosCartCheckout.ReadyPlatformCoupon(data)
      await context.commit('mutationReadyPlatformCoupon', response)
    },
    async actionsCheckoutEstimateCostByProduct (context, data) {
      const response = await AxiosCartCheckout.EstimateCostByProduct(data)
      await context.commit('mutationEstimateCostByProduct', response)
    }
  }
}

export default ModuleCartCheckout
